export default {
	SET_PONDS(state, ponds) {
		state.ponds = ponds;
	},
	REMOVE_RECORD(state, itemId) {
		const userIndex = state.ponds.findIndex(u => u._id == itemId);
		state.ponds.splice(userIndex, 1);
	},
	SET_TOTAL_PONDS(state, total) {
		state.total = total;
	},
	ADD_POND(state, pond) {
		state.ponds.unshift(pond);
	},
	UPDATE_POND(state, pond) {
		const idx = state.ponds.findIndex(t => t._id === pond._id);
		if (idx !== -1) {
			Object.assign(state.ponds[idx], pond);
		}
	}
};
